import { contentDeliveryApi } from './contentDeliveryAPI';
import { ClientAPI } from './index';

export const invalidateUserData = (isLogout: boolean = false) => {
  if (!isLogout) {
    //logout is handled in the mutation for CD api
    contentDeliveryApi.util.invalidateTags(['Global', 'Content']);
  }
  ClientAPI.util.invalidateTags([
    'CartData',
    'CheckoutData',
    'CreditTrackerData',
    'LibraryItem',
    'Library',
    'Licenses',
    'POECRenewalItems'
  ]);
};

export const resetUserData = async (isLogout: boolean = false): Promise<boolean> => {
  try {
    invalidateUserData(isLogout);
    // Reset all API states for a complete RTK Query cache clear
    ClientAPI.util.resetApiState();
    contentDeliveryApi.util.resetApiState();
    return true;
  } catch (error) {
    console.error('Error in resetUserData:', error);
    return false;
  }
};

export const handleLogout = async (): Promise<boolean> => {
  try {
    await resetUserData(true);
    localStorage.removeItem('user-preferences');
    localStorage.removeItem('last-visit');
    sessionStorage.clear();
    return true;
  } catch (error) {
    console.error('Error during logout cleanup:', error);
    return false;
  }
};
